import {useEffect} from 'react'

import {setPreviousPageInfo} from '../utils/previous-page-helper'

export function useSavePageTitle() {
  useEffect(() => {
    const handleBeforeUnload = () => {
      setPreviousPageInfo(document.title)
    }

    window.addEventListener('beforeunload', handleBeforeUnload)

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload)
    }
  }, [])
}
